// extracted by mini-css-extract-plugin
export default {"instructionsList":"InitialInstructions_instructionsList__dtdHH","loadLink":"InitialInstructions_loadLink__Rrzt6"};